import {ChatSubscribers} from '@extensions/chat-subscribers'
import {globals} from '@extensions/globals-base'
import {systemStickerCtl} from '@extensions/sticker/sticker'
import {DataAdapter, Hub, systemStickers} from 'yougile-model'
import {Accounts} from './accounts'
import {Sync} from './sync'

export const makeAdapter = (): DataAdapter => {
  const box = Sync.getCurrentSandbox()

  return {
    companyId: box.companyId,
    userId: globals.currentUserId,
    allUsers: box.getAllUsers(false).map(u => u.id),
    async getAccount(userId) {
      return Accounts.get(userId, true)
    },
    getHub(id) {
      return box.getHub(id).toJSON()
    },
    getUser(id) {
      return box.getUser(id).toJSON()
    },
    getChildrenIds(id) {
      return box.getChildrenIds(id)
    },
    async createHub(hubJson) {
      const hub = new Hub(box.companyId, '').fromJSON(box.companyId, hubJson)
      box.add(hub, hub.location, true, false)
    },
    async setSubscribers(task, userIds) {
      ChatSubscribers.setSubscribedToTaskChat(task.id, userIds)
    },
    getSystemStickerId(sticker) {
      return (
        systemStickerCtl[sticker].getSticker(box)?.id ?? systemStickers[sticker]
      )
    }
  }
}
